import { useLayoutContext } from '@context/LayoutContext';

import { MegaMenuEntry } from '@monofront/types';

export const SimpleNavigation = () => {
  const { megamenu } = useLayoutContext();

  if (!megamenu.collections.length) return null;

  return (
    <nav id="seo-navigation" className="tw-hidden">
      <ul>
        {megamenu.collections.map((collection: MegaMenuEntry) => (
          <li key={collection.linkedCollection.id}>
            <a href={`/collections/${collection.linkedCollection.handle}`}>
              {collection.labelOverride ?? collection.linkedCollection.title}
            </a>
            {collection.subCollections.length > 0 && (
              <ul>
                {collection.subCollections.map(
                  (subCollection: MegaMenuEntry) => (
                    <li key={subCollection.linkedCollection.id}>
                      <a
                        href={`/collections/${subCollection.linkedCollection.handle}`}
                      >
                        {subCollection.labelOverride ??
                          subCollection.linkedCollection.title}
                      </a>
                      {subCollection.subCollections.length > 0 && (
                        <ul>
                          {subCollection.subCollections.map(
                            (sublevel3Collection: MegaMenuEntry) => (
                              <li key={sublevel3Collection.linkedCollection.id}>
                                <a
                                  href={`/collections/${sublevel3Collection.linkedCollection.handle}`}
                                >
                                  {sublevel3Collection.labelOverride ??
                                    sublevel3Collection.linkedCollection.title}
                                </a>
                              </li>
                            ),
                          )}
                        </ul>
                      )}
                    </li>
                  ),
                )}
              </ul>
            )}
          </li>
        ))}
      </ul>
    </nav>
  );
};
